/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import AnimationAwaiter from 'extensions/animation-awaiter';
import {LitElement, html, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import styles from './toast.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

export class Toast extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			message: Object
		};
	}

	constructor () {
		super();

		/** @type {import('../../data/messages-store').Message} */
		this.message = '';
	}

	handleClose () {
		this.message.remove();
	}

	firstUpdated () {
		// Set beforeRemoveHandler on message object
		this.message.beforeRemoveHandler = () => new AnimationAwaiter('#toast', {
			container: this.renderRoot
		}).animationEnd;

		// Prevent message from autoremoving if you hover/focus/click it
		this.addEventListener('mouseover', this.message.stopAutoRemove.bind(this.message), {once: true});
		this.addEventListener('focus', this.message.stopAutoRemove.bind(this.message), {once: true});
		this.addEventListener('click', this.message.stopAutoRemove.bind(this.message), {once: true});
	}

	renderNeedMoreHelp () {
		return html`
			<div class="toast__need-more-help">
				<span>Need more help?</span>
				<rb-chat-widget hide-trigger>
					<button slot="trigger" class="toast__chat-trigger">Talk to an Expert</button>
				</rb-chat-widget>
			</div>
		`;
	}

	render () {
		const rootClassMap = {
			[`type--${this.message?.type}`]: true,
			'animation--slide-out': this.message?.removing === true,
			toast: true
		};

		return html`
			<div id="toast" class="${classMap(rootClassMap)}">
				<span class="toast__icon icon-error-circle" aria-hidden="true"></span>
				<div class="toast__message">
					${this.message?.text}
					${this.message?.type === 'error' ? this.renderNeedMoreHelp() : nothing}
				</div>
				<button class="toast__close-button" aria-label="Close Messsage" @click="${this.handleClose}"><span class="toast__close-button-icon icon-svg-cancel-2" aria-hidden="true"></span></button>
			</div>
		`;
	}
};

defineCustomElement('rb-toast', Toast);
